import { configureStore } from "@reduxjs/toolkit"
import { rootReducer } from "./reducers"
import { searchTermsTrendsApi } from "../modules/SearchTermsTrends/api/searchTermsTrends.api"

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(
      searchTermsTrendsApi.middleware
    ),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
